// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__rjAal","label":"Section_label__2bWB5","contentWrap":"Section_contentWrap__Aytd-","footer":"Section_footer__cwx8Q","footerInner":"Section_footerInner__3noc5"};